module.exports = (__parcel__import__("42gW7")).then(() => parcelRequire('kRw5D'));